<template>
  <div class="category-container">
    <div class="category-header">
      <div class="header-title">商品分类</div>
      <!-- <div class="header-more" @click="goMore">查看更多 ›</div> -->
    </div>
    
    <div class="category-grid">
      <div 
        v-for="(item, index) in categoryList" 
        :key="index" 
        class="category-item"
        @click="handleCategoryClick(item)"
      >
        <div class="category-icon">
          <img :src="item.iconImg" class="category-img" :alt="item.name" />
        </div>
        <div class="category-name">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Category',
  data() {
    return {
      categoryList: [
        { name: '家用电器', icon: '📺', bgColor: 'linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%)',id:'9' ,path:'/goods_collection_list/19',iconImg:'https://bank.giftoceanmall.com/67b97202605261818124879.jpg'},
        { name: '家居百货', icon: '🏠', bgColor: 'linear-gradient(135deg, #ff7875 0%, #ff9c6e 100%)',id:'6' ,path:'/goods_list?id=6&title=家居百货',iconImg:'https://bank.giftoceanmall.com/301df202605261817172770.jpg'},
        { name: '家清日用', icon: '🧴', bgColor: 'linear-gradient(135deg, #ff9c6e 0%, #ff4d4f 100%)',id:'158' ,path:'/goods_list?id=158&title=家清日用',iconImg:'https://bank.giftoceanmall.com/63fee20260526181843766.jpg'},
        { name: '美妆护肤', icon: '💄', bgColor: 'linear-gradient(135deg, #d93636 0%, #ff4d4f 100%)' ,id:'15' ,path:'/goods_list?id=15&title=美妆护肤',iconImg:'https://bank.giftoceanmall.com/2bcd5202605261818566254.jpg'},   
        { name: '腕表黄金', icon: '⌚', bgColor: 'linear-gradient(135deg, #ff7875 0%, #d93636 100%)',id:'16' ,path:'/goods_list?id=16&title=腕表黄金',iconImg:'https://bank.giftoceanmall.com/95b0e202605261819151905.jpg'},
        { name: '影音数码', icon: '🎧', bgColor: 'linear-gradient(135deg, #ff4d4f 0%, #ff9c6e 100%)' ,id:'12' ,path:'/goods_collection_list/17',iconImg:'https://bank.giftoceanmall.com/e861d202605261819345832.jpg'},
        { name: '高端专区', icon: '💎', bgColor: 'linear-gradient(135deg, #ff9c6e 0%, #ff7875 100%)' ,id:'13' ,path:'/goods_collection_list/11',iconImg:'https://bank.giftoceanmall.com/c7b4120260526180159687.jpg'},
        { name: '夏季专区', icon: '❄️', bgColor: 'linear-gradient(135deg, #72c0ff 0%, #40a9ff 100%)' ,id:'179' ,path:'/goods_collection_list/2',iconImg:'https://bank.giftoceanmall.com/f5c0c202605261820045273.jpg'},
        { name: '爆款专区', icon: '🔥', bgColor: 'linear-gradient(135deg, #ff7875 0%, #d93636 100%)',id:'180' ,path:'/goods_collection_list/1',iconImg:'https://bank.giftoceanmall.com/26a1b202605261815095838.jpg'},
        { name: '捡漏专区', icon: '💰', bgColor: 'linear-gradient(135deg, #ffc53d 0%, #faad14 100%)',id:'181' ,path:'/goods_collection_list/12',iconImg:'https://bank.giftoceanmall.com/59de1202605261820491378.jpg'}
      ]
    }
  },
  methods: {
    handleCategoryClick(item) {
      if (item.path) {
        this.$router.push(item.path)
      }
      this.$emit('categoryClick', item)
    },
    goMore() {
      this.$router.push({ path: '/category' })
    },
  }
}
</script>

<style lang="scss" scoped>
.category-container {
  background: #fff;
  padding: 0.3rem;
  margin-top: 0.2rem;
}

.category-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.3rem;
  
  .header-title {
    font-size: 0.32rem;
    font-weight: bold;
    color: #333;
  }
  
  .header-more {
    font-size: 0.24rem;
    color: #999;
  }
}

.category-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 0.25rem;
}

.category-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.2rem 0;
  
  &:active {
    opacity: 0.7;
  }
}

.category-icon {
  width: 1.2rem;
  height: 1.2rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.15rem;
  overflow: hidden;
  
  .category-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.category-name {
  font-size: 0.22rem;
  color: #333;
  text-align: center;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 移动端适配 */
@media screen and (max-width: 480px) {
  .category-container {
    padding: 0.25rem;
  }
  
  .category-grid {
    gap: 0.2rem;
  }
  
  .category-icon {
    width: 1.1rem;
    height: 1.1rem;
    
    .category-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  
  .category-name {
    font-size: 0.2rem;
  }
}
</style>